const SET_LOADED = "SET_LOADED";

const SetLoaded = (loaded: boolean) => ({
  type: SET_LOADED,
  payload: loaded
});

export default { SET_LOADED, SetLoaded };
